import { render, staticRenderFns } from "./joining.vue?vue&type=template&id=56ef5e9f&scoped=true&"
import script from "./joining.vue?vue&type=script&lang=js&"
export * from "./joining.vue?vue&type=script&lang=js&"
import style0 from "./joining.vue?vue&type=style&index=0&id=56ef5e9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef5e9f",
  null
  
)

export default component.exports